import { Label } from "baseui/form-control/styled-components";
import {
  FieldTypes,
  FormFieldRequest,
  FormFieldRequestTouched,
  FormRequest,
  FormRequestTouched,
} from "../types/forms";

export const FORM_DEFAULTS: FormRequest = {
  name: "",
  tenants: [],
  active: undefined,
};

export const FORM_TOUCHED_DEFAULTS: FormRequestTouched = {
  nameTouched: false,
};

export const FORM_FIELD_DEFAULTS: FormFieldRequest = {
  fieldType: FieldTypes.string,
  name: "",
  order: 0,
  pdfVisible: true,
  required: true,
  default: "",
  help_text: "",
  options: [],
  prefix: "",
  sufix: "",
  active: undefined,
};

export const FORM_FIELD_TOUCHED_DEFAULTS: FormFieldRequestTouched = {
  fieldTypeTouched: false,
  nameTouched: false,
  orderTouched: false,
};

export const FIELD_TYPE_OPTIONS = [
  {
    id: FieldTypes.text,
    label: "Texto",
  },
  {
    id: FieldTypes.string,
    label: "Cadena de texto",
  },
  {
    id: FieldTypes.boolean,
    label: "Booleano",
  },
  {
    id: FieldTypes.choice,
    label: "Selección simple",
  },
  {
    id: FieldTypes.multiple_choice,
    label: "Selección multiple",
  },
  {
    id: FieldTypes.date,
    label: "Fecha",
  },
  {
    id: FieldTypes.datetime,
    label: "Fecha y hora",
  },
  {
    id: FieldTypes.time,
    label: "Hora",
  },
  {
    id: FieldTypes.duration,
    label: "Duración",
  },
  {
    id: FieldTypes.float,
    label: "Número flotante",
  },
  {
    id: FieldTypes.integer,
    label: "Número entero",
  },
  {
    id: FieldTypes.email,
    label: "Correo electrónico",
  },
  {
    id: FieldTypes.ip_address,
    label: "Dirección IP",
  },
  {
    id: FieldTypes.url,
    label: "URL",
  },
  {
    id: FieldTypes.file,
    label: "Archivo",
  },
  {
    id: FieldTypes.canvas,
    label: "Canvas",
  },
  {
    id: FieldTypes.image,
    label: "Imagen",
  },
  {
    id: FieldTypes.signature,
    label: "Firma",
  },
];

export const BOOLEAN_DEFAULT_VALUE_OPTIONS = [
  {
    id: "true",
    label: "True",
  },
  {
    id: "false",
    label: "False",
  },
];

export const RELATED_ATTRIBUTE_OPTIONS = [
  {
    id: "assetId",
    label: "Asset ID",
  },
  {
    id: "marca",
    label: "Marca",
  },
  {
    id: "submarca",
    label: "Submarca",
  },
  {
    id: "modelo",
    label: "Modelo",
  },
  {
    id: "placa",
    label: "Placa",
  },
  {
    id: "vin",
    label: "Vin",
  },
];
